import LoginPage from "@/pages/login/LoginPage";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { LazyLoadingSpinner } from "@/components/LazyLoadingSpinner";

export const Route = createFileRoute("/login")({
  component: LoginPage,
  beforeLoad: async ({ context: { isAuthenticated } }) => {
    if (isAuthenticated) {
      throw redirect({ to: "/home" });
    }
    return { isAuthenticated };
  },
  pendingComponent: () => <LazyLoadingSpinner />
});
